/** @file LintList: the puppet's slot and pivot warnings, each with a "jump to slot" button. */
import type { ReactElement } from 'react';
import type { SlotWarning } from './slotWarnings';

/** The warnings to list and what jumping to a slot does. */
export type LintListProps = { items: SlotWarning[]; onJump: (slot: string) => void };

const CODE_COLOR: Partial<Record<string, string>> = { EMPTY_SLOT: '#8a8f98', PIVOT_OUTSIDE: '#e05555', IMAGE_RESIZED: '#d9a227' };

/** One row per warning (code, message); rows naming a slot get a Jump button; "No slot warnings." when empty. */
export function LintList({ items, onJump }: LintListProps): ReactElement {
  return (
    <section aria-label="Lint" style={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1, minHeight: 0, overflow: 'auto', fontSize: 11 }}>
      <h4 style={{ margin: '4px 0', fontSize: 12 }}>Lint ({items.length})</h4>
      {items.length === 0 ? <span style={{ color: '#a9adb6' }}>No slot warnings.</span> : null}
      {items.map(({ warning, slot }, i) => (
        <div key={`${warning.code}-${warning.path ?? ''}-${String(i)}`} style={{ display: 'flex', gap: 6, alignItems: 'baseline' }}>
          <code style={{ color: CODE_COLOR[warning.code] ?? '#a9adb6', flex: 'none' }}>{warning.code}</code>
          <span style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>{warning.message}</span>
          {slot === null ? null : (
            <button type="button" onClick={() => { onJump(slot); }} style={{ fontSize: 11, cursor: 'pointer' }}>Jump to slot</button>
          )}
        </div>
      ))}
    </section>
  );
}
